<div class="content-container nigeria-single-view">
  <div class="layout-container">

    <!-- Mobile-only collapse/expand toggle for the filter bar -->
    <button type="button" class="filter-collapse-toggle" (click)="toggleFilter()">
      <i [ngClass]="isFilterCollapsed ? 'fas fa-sliders-h' : 'fas fa-chevron-up'"></i>
      <span>{{ isFilterCollapsed ? 'Show filters' : 'Hide filters' }}</span>
    </button>

    <!-- ——— Horizontal filter bar (top) ——— -->
    <div [ngClass]="isMobileView() ? 'filter-container-mobile' : 'filter-container'"
         [class.collapsed]="isFilterCollapsed">

      <div class="filter-section slider-height" dir="rtl">
        <label for="year">price range:</label>
        <div class="slider-range-values">
          <span></span>
          <span>&#8358; {{ priceService.landedNgn(sliderValue) | number:'1.0-0' }}</span> -
          <span *ngIf="!isPriceAtMax">&#8358; {{ priceService.landedNgn(sliderHighValue) | number:'1.0-0' }}</span>
          <span *ngIf="isPriceAtMax">Any</span>
          <span></span>
        </div>
        <div class="custom-slider">
          <ngx-slider
            [value]="sliderValue"
            [highValue]="sliderHighValue"
            [options]="sliderOptions"
            (userChangeEnd)="onPriceSliderEnd($event)">
          </ngx-slider>
        </div>
      </div>

      <div class="filter-section">
        <label for="year">year:</label>
        <select id="year" name="year"
                [(ngModel)]="selectedYear"
                (change)="onYearChange($event.target.value)">
          <option *ngFor="let year of filterMetaYears" [value]="year">{{ year }}</option>
        </select>
      </div>
      <div class="filter-section">
        <label for="make">make:</label>
        <select id="make" name="make" [value]="selectedMake" (change)="onMakeChange($event.target.value)" class="constrained-width-select">
          <option *ngFor="let make of makes" [value]="make">{{ make }}</option>
        </select>
      </div>
      <div class="filter-section">
        <label for="model">model:</label>
        <select id="model" name="model" [value]="selectedModel" (change)="onModelChange($event.target.value)"
                class="model-select">
          <option *ngFor="let model of models" [value]="model" class="model-select">{{ model }}</option>
        </select>
      </div>
      <div class="filter-section">
        <label for="fuel">Fuel type:</label>
        <select id="fuel" name="fuel" (change)="onFuelChange($event.target.value)">
          <option *ngFor="let fuel of fuelTypes" [value]="fuel">{{ fuel }}</option>
        </select>
      </div>
      <div class="filter-section slider-height" dir="rtl">
        <label for="year">Mileage (KM):</label>
        <div class="slider-range-values">
          <span></span>
          <span>{{(sliderKmValue | number) + ' km' }}</span> -
          <span>{{(sliderKmHighValue | number) + 'km ' }}</span>
          <span></span>
        </div>
        <div class="custom-slider">
          <ngx-slider
            [value]="sliderKmValue"
            [highValue]="sliderKmHighValue"
            [options]="sliderKmOptions"
            (userChangeEnd)="onKmSliderEnd($event)">
          </ngx-slider>
        </div>
      </div>

      <div class="filter-section">
        <label>condition:</label>
        <div class="inline-radio-group">
          <label>
            <input type="radio" name="SaleCondition" value="New" [(ngModel)]="saleCondition"
                   (change)="onCarSaleConditionToggleChange($event)"> New
          </label>
          <label>
            <input type="radio" name="SaleCondition" value="Used" [(ngModel)]="saleCondition"
                   (change)="onCarSaleConditionToggleChange($event)"> Used
          </label>
          <label>
            <input type="radio" name="SaleCondition" value="All" [(ngModel)]="saleCondition"
                   (change)="onCarSaleConditionToggleChange($event)"> All
          </label>
        </div>
      </div>

      <div class="filter-section filter-section-button">
        <button class="Dialog" mat-raised-button color="warn" (click)="filter('normal')">
          <i class="fas fa-search"></i> Filter
        </button>
      </div>
    </div>

    <ng-template #loadingOverlay>
      <div class="loading-overlay">
        <mat-spinner></mat-spinner>
      </div>
    </ng-template>

    <!-- ——— Car grid (full width, below bar) ——— -->
    <div id="cardContainer" #carContainer [class.car-container-desktop]="!isMobileView()"
         [class.car-container-mobile]="isMobileView()" class="car-container" dir="ltr">
      <div class="card-container">
        <ng-container  *ngFor="let car of cars">
          <mat-card
            *ngIf="car.url"
            [ngClass]="{'card-item-m': isMobileView(), 'card-item': !isMobileView(), 'authorized-border': car.authorized_seller, 'regular-border': !car.authorized_seller}"
            matRipple fxLayout="column" fxFlex>
            <div style="height: 110px;width: calc(100% + 32px);margin: 0 -16px 0 -16px;"
                 class="car-image-container">
              <img
                mat-card-image
                class="card-image"
                [src]="car.url"
                (error)="handleImageError(car)"
                alt="{{car.Manufacturer}} {{car.Model}}"
                (click)="openDialog(car)"
                height="110px" />
              <span class="illustration-text">Photo for reference only. Actual vehicle details may differ.</span>
            </div>
            <fa-icon class="heart-icon" [icon]="car.isLiked ? fasFaHeart : farFaHeart"
                     (click)="toggleLike(car)"></fa-icon>

            <fa-icon *ngIf="car.myCarId !== null" class="cart-icon" [icon]="faShoppingCart"></fa-icon>

            <svg-icon *ngIf="car.Location === 'Israel'" class="location"
                      [src]="'/assets/icons/countries/'+ (car.Location ? 'israel' : 'israel') +'.svg'"
                      [svgStyle]="{width:'16px'}" [nbTooltip]="'CAR_MARKET.LOCATED_IN_ISRAEL' | translate"></svg-icon>

            <mat-card-content class="mat-card-content">

              <div class="m-1 pt-3">
                <div class="overview-style">
                  <div [ngStyle]="{ 'background-color': '#5f7dff', 'border-bottom': '0px' }"
                       class="overview-cart parent-cart">
                    <div class="inner-header flex-row">
                      <span class="mt-4 heading-text white"
                            [ngClass]="{ 'size12': car.Manufacturer === 'Mercedes-Benz', 'size14': car.Manufacturer !== 'Mercedes-Benz' }">
                        {{ car.Manufacturer }}
                      </span>
                      <span class="mt-4 heading-id-text size14">{{car.id}}</span>
                      <img *ngIf="car.IsHot" class="mt-4 hot-icon" src="/assets/images/fire-30.png" alt=""
                           width="25" height="30" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="more-info">
                <div class="flex-row location-info">
                  <span class="flex-cell location-text mr-4 bold pull-left" style="float:left;">{{
                      getFuelTypeHebrew(car.FuelType) }}</span>
                  <span class="flex-cell location-text mr-4 bold pull-left truncate">{{ car.FinishLevel }}</span>
                  <span class="flex-cell location-text mr-4 bold pull-left truncate" direction="ltr">{{ car.Model
                    }}</span>

                </div>
                <div class="extra-info">
                  <div class="flex-table">
                    <div class="flex-row" *ngIf="!showDirham">
                      <div *ngIf="importType === 'Commercial'" class="flex-cell bold big price">
                        &#8358; {{ priceService.landedNgnFromFob(car.CarPrice) | number:'1.0-0' }}<br />
                        <span class="small" style="font-size:8pt">
                          {{ 'CAR_MARKET.PRICE_FROM_LAST_UPDATE' | translate }}
                        </span>
                      </div>
                      <div *ngIf="importType === 'Taxi'" class="flex-cell bold big price" style="height:55px">
                        <div
                          style="flex-direction: row; align-items: center; display: flex;justify-content: space-around">
                          <div><img src="/assets/images/Taxi_logo.png" alt="" width="60" height="20"
                                    style="border:2px solid black; border-radius: 4px" /></div>
                          <span>{{ car.C_PriceComTaxi | currency: 'USD' : 'symbol' : '1.0-0' }}</span>
                        </div>
                        <div style="margin-top: 0px;">
                          <span class="small" style="font-size:8pt">{{ 'CAR_MARKET.ESTIMATED_PRICE' | translate }} </span>
                          <span class="small" style="font-size:9pt; font-weight: bold">{{ 'CAR_MARKET.FOR_TAXI' | translate }}</span>
                          <span class="small" style="font-size:8pt">{{ 'CAR_MARKET.AFTER_CUSTOMS' | translate }} </span>
                        </div>
                      </div>
                    </div>
                    <div class="flex-row" *ngIf="showDirham">
                      <div class="flex-cell bold big price">
                        &#8358; {{ priceService.landedNgnFromFob(car.CarPrice) | number:'1.0-0' }}<br />
                        <span class="small" style="font-size:8pt">
                          Estimated price after customs release
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="extra-info-engine">
                  <div class="flex-table">
                    <div class="flex-row bold">
                      <div class="flex-cell">Man. year</div>
                      <div class="flex-cell">Color</div>
                      <div class="flex-cell">Mileage (KM)</div>
                    </div>
                    <div class="flex-row">
                      <div class="flex-cell">{{car.ManufactureDate | date:'yyyy'}}</div>
                      <div class="flex-cell truncate">{{car.ExteriorColor}}</div>
                      <div class="flex-cell">{{car.Mileage | number: '1.0-0'}}</div>
                    </div>
                  </div>
                </div>
                <div *ngIf="false" class="extra-info-engine"
                     (click)="showArbDisclaimer(car)">
                  <div *ngIf="getArbitrageDiff(car) !== null" class="flex-row bold engine-text">
                    <fa-icon class="tag-icon" [icon]="faCertificate"></fa-icon>
                    <div class="flex-cell-full">*חסכון מ״מחיר שוק משוער״</div>
                  </div>
                  <div *ngIf="getArbitrageDiff(car) !== null" class="flex-row bold arbitrage-text">
                    <div class="flex-cell">{{(getArbitrageDiff(car)  || 0)|currency:'USD':'symbol':'1.0-0'}}</div>
                  </div>
                </div>

                <div class="flex-table">
                  <div class="flex-row bold" *ngIf="car.Source?.trim()?.toLocaleLowerCase() === 'hertz'">
                    <svg-icon class="hertz-logo"
                              [svgStyle]="{width:'210px', height:'50px'}"
                              [src]="'/assets/Hertz-Logo.svg'"
                              nbTooltip="Hertz"></svg-icon>

                  </div>
                  <div class="flex-row bold copart-logo" *ngIf="car.Source?.trim()?.toLocaleLowerCase() === 'openlane'">
                    <a href="https://www.openlane.com/" target="_blank" rel="noopener noreferrer">
                      <svg-icon class="hertz-logo"
                                [svgStyle]="{width:'210px', height:'50px'}"
                                [src]="'/assets/Openlane-Logo.svg'"
                                nbTooltip="OpenLane"></svg-icon>
                    </a>
                  </div>
                  <div class="flex-row bold copart-logo" *ngIf="car.Source?.trim()?.toLocaleLowerCase() === 'copart'" >
                      <svg-icon class="hertz-logo"
                                [svgStyle]="{width:'210px', height:'50px', 'margin-top':'5px'}"
                                [src]="'/assets/copart.svg'"
                                nbTooltip="Copart"></svg-icon>
                  </div>
                </div>
              </div>

              <div class="card-actions">
                <button id="cars-grid-more-info-button" mat-raised-button color="primary"
                        class="interested-button full-width" (click)="handleClick(car)">more info
                </button>
              </div>
            </mat-card-content>
          </mat-card>
        </ng-container>
        <div class="spinner-container">
          <button mat-button class="load-more-button" color="accent" (click)="handleLoadMore()">
            <mat-icon>expand_more</mat-icon>
            {{ 'CAR_MARKET.LOAD_MORE' | translate }}
          </button>
        </div>
      </div>
    </div>
    <button *ngIf="showScrollButton" (click)="scrollToTop()" class="scroll-to-top-btn">
      <i class="fas fa-arrow-up"></i>
    </button>
    <ng-container #host style="display: none"></ng-container>
  </div>
</div>
